import { useState, useEffect } from 'react';
import { UseTypingAnimationProps } from '../types/useTypingAnimation';
export const useTypingAnimation = ({
  typeText,
  typingSpeed = 50,
  pauseAfterTyped = 2000,
  pauseAfterDelete = 500,
}: UseTypingAnimationProps) => {
  const [displayed, setDisplayed] = useState('');
  const [typing, setTyping] = useState(true);
  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (typing) {
      if (displayed.length < typeText.length) {
        timeout = setTimeout(() => {
          setDisplayed(typeText.slice(0, displayed.length + 1));
        }, typingSpeed);
      } else {
        timeout = setTimeout(() => setTyping(false), pauseAfterTyped);
      }
    } else {
      if (displayed.length > 0) {
        timeout = setTimeout(() => {
          setDisplayed(typeText.slice(0, displayed.length - 1));
        }, 18);
      } else {
        timeout = setTimeout(() => setTyping(true), pauseAfterDelete);
      }
    }
    return () => clearTimeout(timeout);
  }, [displayed, typing, typeText, typingSpeed, pauseAfterTyped, pauseAfterDelete]);
  return { displayed, typing };
};
